import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TransformationShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="transformation-showcase" className="dark bg-background text-foreground relative flex min-h-[60vh] items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570251/img/luxury_pool_deck.png')] bg-cover bg-center blur-sm scale-105" />
        {}
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {}
      <div ref={ref} className={`container relative z-10 mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="mb-6 text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-7xl">
          The Art of Protection
        </h1>
        
        <p className="mx-auto mb-10 max-w-2xl text-lg text-muted-foreground md:text-xl">
          Browse our portfolio of completed projects across the island.
        </p>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" className="h-12 px-8 text-base">
            <Link to="/ProjectGalleryPage">
              View Project Gallery
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}